module.exports = __webpack_public_path__ + "img/LMS-Courses-2.65419aa7.svg";